<template>
  <div class="content">
    <card>
      <div class="row">
        <div v-if="state.state === 1" class="col-md-4">
          <base-button @click="setSiteOrder" type="default">노출순서변경</base-button>

          <el-popover trigger="hover" placement="top">
            <div>
              <div class="popover-body">드래그앤드랍으로 노출순서를 변경할 수 있습니다</div>
            </div>
            <base-button slot="reference"> ? </base-button>
          </el-popover>
        </div>
        <base-button @click="goSiteForm()" type="default">사이트 등록</base-button>
      </div>
    </card>
    <draggable class="row" v-model="sites" group="people" @start="drag = true" @end="drag = false">
      <div class="col-sm-3" v-for="(item, index) in sites">
        <card class="card">
          <div class="row">
            <img v-if="item.imageFileUrl" slot="image" class="card-img-top cover-img" v-bind:src="item.imageFileUrl" :alt="item.title" />
            <img v-else src="@/assets/img/blip-logo.png" />
          </div>
          <p>{{ item.typeName }}</p>
          <p>{{ item.title.ko }}</p>
          <p class="card-text">{{ item.startTime }}</p>
          <p>{{ item.endTime }}</p>
          <base-button @click="goSiteForm(item.id)" type="default">상세</base-button>
        </card>
      </div>
    </draggable>
  </div>
</template>
<script>
import { BaseButton, Card } from "@/components/index";
import draggable from "vuedraggable";
import { formatDateTime } from "../../util/DateUtils";
import { HomepageBannerType } from "@/pages/Homepage/HomepageBannerType";

export default {
  components: {
    Card,
    BaseButton,
    draggable,
  },
  async created() {
    this.types = [{ name: "전체", type: null }, ...this.types];
    await this.getSites();
  },
  data() {
    return {
      state: {
        state: 1,
        options: [
          { label: "전체", value: null },
          { label: "표시", value: 1 },
          { label: "숨김", value: 0 },
        ],
      },
      type: 0,
      sites: [],
      types: HomepageBannerType,
    };
  },
  methods: {
    async getSites() {
      return this.$axios.get(`/homepage/sites`, { params: { state: this.state.state, type: this.type } }).then((res) => {
        this.sites = res.data.data.map((site) => {
          site.imageFileUrl = window.Endpoints.imageServerUrl + site.imageFileId;
          site.startTime = formatDateTime(site.startTime);
          site.endTime = formatDateTime(site.endTime);
          site.typeName = this.types
            .map((type) => {
              if (type.type === site.type) {
                return type.name;
              } else {
                return null;
              }
            })
            .filter((type) => type !== null)
            .toString();
          return site;
        });
      });
    },
    async setSiteOrder() {
      const sites = [];
      this.sites.forEach((site, order) => {
        sites.push({ siteId: site.id, order });
      });
      return this.$axios.put("/homepage/sites/order", { sites }).then((res) => {
        window.Toast.success("사이트의 노출순서가 변경되었습니다");
        this.getSites();
      });
    },
    goSiteForm(siteId) {
      if (siteId) {
        this.$router.push(`/homepage/siteForm?siteId=${siteId}`);
      } else {
        this.$router.push(`/homepage/siteForm`);
      }
    },
  },
};
</script>
<style></style>
